require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.object.to-string");

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};